import { Component, OnInit, ViewChild } from '@angular/core';
import { NavParams, AlertController, ModalController, IonContent, IonInfiniteScroll } from '@ionic/angular';
import { PtyLdService } from 'src/app/services/pty-ld.service';
import { PtyWsService } from 'src/app/services/pty-ws.service';
import { TranslationService } from "../../services/translation.service";
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-seeker-request-templates',
    templateUrl: './seeker-request-templates.component.html',
    styleUrls: ['./seeker-request-templates.component.scss'],
})
export class SeekerRequestTemplatesComponent implements OnInit {

    userTemplates: any = [];
    public show: boolean = false;

    title: any = '';
    template: any = '';
    showTextArea: boolean = false;
    selectedItem: any;

    myTemplates: any = [];
    adminTemplates: any = [];
    allMyTemplates: any = [];
    allAdminTemplates: any = [];
    myTemplatesSearched: any = [];
    adminTemplatesSearched: any = [];
    showtemplatebody = false;
    minusbutton = true;
    plusbutton = false;
    elemntindex = null;
    showsearch = false;
    showtemplatebodyadmin = false;
    searchtemplate = '';
    creationCount = 0;
    orderChanged = false

    myTemplatesPage = 0;
    adminTemplatesPage = 0;
    templatesByPage = 10;
    totalMyTemplates = 0;
    totalAdminTemplates = 0;
    saveOrderButtonLabel = 'No changes to save';
    saveOrderIsLoading = false;

    userSearchLastKeystrokeTime: number;
    isSearchTimeoutRunning: boolean = false;
    isLoadMoreRunning: boolean = false;
    isPageCurrentlyLoaded: boolean = true;

    @ViewChild(IonContent, { static: true }) content: IonContent;
    @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;

    constructor(
        private navParams: NavParams,
        private alertCtrl: AlertController,
        private ld: PtyLdService,
        private ws: PtyWsService,
        private modalCtrl: ModalController,
        private _translationService: TranslationService
    ) {
        this.userTemplates = this.navParams.get('templates');

    }

    ngOnInit() {
        this.loadTemplates();
    }

    ionViewWillEnter() {
        this.isPageCurrentlyLoaded = true;
        this.isLoadMoreRunning = false;
    }

    ionViewWillLeave() {
        this.isPageCurrentlyLoaded = false;
    }

    loadTemplates() {
        //Get the templates from local storage
        this.allMyTemplates = JSON.parse(localStorage.getItem('myTemplatesInstorage'));
        this.allAdminTemplates = JSON.parse(localStorage.getItem('adminTemplatesInstorage'));

        if (!this.allMyTemplates || typeof this.allMyTemplates !== 'object' || this.allMyTemplates.length === 0) {
            this.allMyTemplates = this.userTemplates.filter(e => e.uploaded_by !== 'A');
            this.allMyTemplates.sort((a,b) => a.template_order - b.template_order);
        }

        if (!this.allAdminTemplates || typeof this.allAdminTemplates !== 'object' || this.allAdminTemplates.length === 0) {
            this.allAdminTemplates = this.userTemplates.filter(e => e.uploaded_by == 'A');
            this.allAdminTemplates.sort((a,b) => a.template_order - b.template_order);
        }

        if (this.allMyTemplates && this.allAdminTemplates) {
            //Save the total length of templates to hide the "Load more Templates"
            this.totalMyTemplates = this.allMyTemplates.length;
            this.totalAdminTemplates = this.allAdminTemplates.length;

            //Load firts page of admin templates
            this.adminTemplates = this.allAdminTemplates.slice(0, this.templatesByPage);
            this.adminTemplates.sort((a,b) => a.template_order - b.template_order);
            this.adminTemplatesPage = 1;


            if(this.totalAdminTemplates < this.templatesByPage){
                //If admin templates have less templates that determined by each page load admin templates and first page of my templates
                this.myTemplates = this.allMyTemplates.slice(0, this.templatesByPage);
                this.myTemplates.sort((a,b) => a.template_order - b.template_order);
                this.myTemplatesPage = 1;
            }
            
            return;
        }

        //If they are not any templates in local storage, then it should bring them from the backend
        this.loadUserTemplates();
    }

    doLocalReorder(ev: any) {
        this.myTemplates = ev.detail.complete(this.myTemplates);
        localStorage.setItem('myTemplatesInstorage', JSON.stringify(this.myTemplates));
        if (!this.orderChanged) {
            this.orderChanged = true;
            this.saveOrderButtonLabel = 'Save Order';
            setTimeout(() => {
                if (!this.orderChanged) {
                    return;
                }
                this.orderChanged = false;
                this.reorderTemplates();
            }, 10000);
        }
    }

    async reorderTemplates() {
        const self = this;
        try {
            // self.ld.showLoading(true); // Commented intentionally to avoid showing the loading spinner
            const reorderResult: {error?: number, message?: string} = await firstValueFrom(self.ws.invokeURL('conversation_templates', { option: 'reorder', templates: self.myTemplates }));
            if (reorderResult.error === 0) {
                self.ld.showLoading(false);
                this.ld.showToast(this._translationService.translate('TemplatesOrderSavedSuccessfully'));
                this.loadUserTemplates();
                return true
            } else {
                self.ld.showLoading(false, { message: reorderResult.message });
                return false;
            } 
        } catch (error) {
            console.error('Error reordering templates', error);
            self.ld.showLoading(false, { message: this._translationService.translate('UnknownError') });
            return false;
        }
    }

    loadMoreTemplates() {
        let remainingAdminTemplates =  this.totalAdminTemplates - this.adminTemplates.length;
        if(remainingAdminTemplates > 0){
            if (this.allAdminTemplates) {
                this.adminTemplates = this.adminTemplates.concat(this.allAdminTemplates.slice(this.adminTemplatesPage * this.templatesByPage, (this.adminTemplatesPage * this.templatesByPage) + this.templatesByPage));
                this.adminTemplatesPage++;
            }
        }
        if (remainingAdminTemplates < this.templatesByPage) {
            if (this.allMyTemplates) {
                this.myTemplates = this.myTemplates.concat(this.allMyTemplates.slice(this.myTemplatesPage * this.templatesByPage, (this.myTemplatesPage * this.templatesByPage) + this.templatesByPage));
                this.myTemplatesPage++;
            }
        }
    }

    loadMoreSearchedTemplates() {
        if (this.myTemplatesSearched.length > 0 && this.myTemplates.length < this.myTemplatesSearched.length) {
            this.myTemplates = this.myTemplates.concat(this.myTemplatesSearched.slice(this.myTemplatesPage * this.templatesByPage, (this.myTemplatesPage * this.templatesByPage) + this.templatesByPage));
            this.myTemplatesPage++;
        }
        if (this.adminTemplatesSearched.length > 0 && this.adminTemplates.length < this.adminTemplatesSearched.length) {
            this.adminTemplates = this.adminTemplates.concat(this.adminTemplatesSearched.slice(this.adminTemplatesPage * this.templatesByPage, (this.adminTemplatesPage * this.templatesByPage) + this.templatesByPage));
            this.adminTemplatesPage++;
        }
    }

    async confirmationAlert(event, obj: any) {
        if (event) {
            event.stopPropagation();
        }

        const alert = await this.alertCtrl.create({
            header: this._translationService.translate('Alert'),
            message: this._translationService.translate('DeleteTemplateQuery'),
            buttons: [
                {
                    text: this._translationService.translate('No'),
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: (blah) => {
                        console.error('Confirm Cancel: blah');
                    }
                }, {
                    text: this._translationService.translate('Yes'),
                    handler: () => {
                        this.save('delete', obj.message_template, obj.title, obj.uuid);
                    }
                }
            ]
        });

        await alert.present();
    }

    elementSwitcher(index) {
        this.userTemplates[index].show = !this.userTemplates[index].show;
    }

    createTemplate() {
        this.showTextArea = true;
        this.showsearch = false
    }

    displaySearch() {
        this.showTextArea = false;
        this.showsearch = !this.showsearch;
        if (!this.showsearch) {
            if (this.searchtemplate.length) this.cleanSearch();
            this.searchtemplate = '';
        }
    }

    handleSearchUserTyping() {
        // Call handleSearch() once the user has stopped typing for over 400 ms
        const oldUserSearchLastKeystrokeTime = this.userSearchLastKeystrokeTime;
        const typingSearchTimeoutMilliseconds = 400;
        this.userSearchLastKeystrokeTime = (new Date()).getTime();
        const typingSearchCallback = () => {
            if (!this.isPageCurrentlyLoaded) {
                this.isSearchTimeoutRunning = false;
                return;
            }
            const currentTimeInMilliseconds = (new Date()).getTime();
            if (currentTimeInMilliseconds < this.userSearchLastKeystrokeTime + typingSearchTimeoutMilliseconds) {
                setTimeout(typingSearchCallback, typingSearchTimeoutMilliseconds);
                return;
            }
            this.isSearchTimeoutRunning = false;
            this.handleSearch();
        };
        // Only run the timeout if it's not already running
        if (!this.isSearchTimeoutRunning) {
            this.isSearchTimeoutRunning = true;
            setTimeout(typingSearchCallback, typingSearchTimeoutMilliseconds);
        }
    }

    handleSearch() {
        this.adminTemplatesPage = 0;
        this.myTemplatesPage = 0;
        if (this.searchtemplate.length > 0) {
            let search = this.searchtemplate.toLowerCase();
            this.myTemplates = [];
            this.adminTemplates = [];
            // It's not necessary filter records with e.uploaded_by !=='A' because allMyTemplates only have user templates
            // It's not necessary sort the templates because they are already sorted when they are loaded
            this.myTemplatesSearched = this.allMyTemplates.filter(e => e.message_template.toLowerCase().includes(search) || e.title.toLowerCase().includes(search));

            // It's not necessary filter records with e.uploaded_by === 'A' because allAdminTemplates only have admin templates.
            // It's not necessary sort the templates because they are already sorted when they are loaded
            this.adminTemplatesSearched = this.allAdminTemplates.filter(e => e.message_template.toLowerCase().includes(search) || e.title.toLowerCase().includes(search));

            // Load just the first page of searched templates. The rest of the templates will be loaded when the user scrolls down
            this.loadMoreSearchedTemplates();
        } else {
            this.cleanSearch();
        }
    }

    cleanSearch() {
        // Clear the search results
        this.myTemplatesSearched = [];
        this.adminTemplatesSearched = [];
        // Clear templates
        this.myTemplates = [];
        this.adminTemplates = [];
        // Reset the pages to 0
        this.adminTemplatesPage = 0;
        this.myTemplatesPage = 0;
        // When search is empty, show again the first page of templates
        this.loadMoreTemplates();
    }

    cancelTemplate() {
        this.template = '';
        this.title = '';
        this.selectedItem = '';
        this.showTextArea = false;
    }
    viewbodyadmin(t) {
        if (this.showtemplatebodyadmin == true) {
            if (t == this.elemntindex) {
                this.showtemplatebodyadmin = false
                this.elemntindex = t
            } else {
                this.elemntindex = t
            }
        } else {
            this.showtemplatebodyadmin = true
            this.elemntindex = t
        }
    }
    editTemplate(event, t) {
        if (event) {
            event.stopPropagation();
        }
        this.selectedItem = t;
        this.showTextArea = true;
        this.template = t.message_template;
        this.title = t.title;
        this.scrollToTop();
    }

    scrollToTop() {
        this.content.scrollToTop(1500);
    }
    viewbody(t) {

        if (this.showtemplatebody == true) {
            if (t == this.elemntindex) {
                this.showtemplatebody = false
                this.elemntindex = t
            } else {
                this.elemntindex = t
            }
        } else {
            this.showtemplatebody = true
            this.elemntindex = t
        }
    }
    saveTemplate() {
        if (this.title === '') {
            this.ld.showToast(this._translationService.translate('TitleMissing'));
            return;
        }
        if (this.selectedItem) {
            this.save('update', this.template, this.title, this.selectedItem.uuid);
        } else {
            this.save('add', this.template, this.title);
        }
    }

    save(option: any, msg: any, title: any, uuid: any = null) {
        const self = this;
        self.ld.showLoading(true).then(() => {
            // tslint:disable-next-line: max-line-length
            self.ws.invokeURL('conversation_templates', { option: option, message: msg, title: title, template_uuid: uuid, creation_count: self.creationCount }).subscribe((result: any) => {
                if (result.error === 0) {
                    if (option === 'add') {
                        let newTmpl = { uuid: result.template, message_template: msg, title: title };
                        self.userTemplates.unshift(newTmpl);
                        self.myTemplates.unshift(newTmpl);
                        localStorage.setItem('myTemplatesInstorage', JSON.stringify(self.myTemplates));
                        self.creationCount++;
                        this.showTextArea = false;
                        this.orderChanged = true;
                        this.saveOrderButtonLabel = 'Save Order';
                    } else if (option === 'delete' || option === 'update') {
                        let idx = self.myTemplates.map((el: any) => el.uuid).indexOf(uuid);
                        if (idx >= 0) {
                            if (option === 'delete') {
                                // removed from local storage
                                self.userTemplates.splice(idx, 1);
                                self.myTemplates.splice(idx, 1);
                                this.orderChanged = true;
                                this.saveOrderButtonLabel = 'Save Order';
                                self.ld.showToast(this._translationService.translate('TemplateDeleteSuccess'));
                            } else {
                                // Update the template in local storage
                                self.userTemplates[idx].edited = false;
                                self.userTemplates[idx].message_template = msg;
                                self.userTemplates[idx].title = title;

                                self.myTemplates[idx].message_template = msg;
                                self.myTemplates[idx].title = title;

                                this.showTextArea = false;
                                self.ld.showToast(this._translationService.translate('TemplateUpdateSuccess'));
                            }
                        }
                    }
                    //Load Templates again after saving changes
                    // self.loadUserTemplates();
                    self.ld.showLoading(false);
                } else {
                    self.ld.showLoading(false, { message: result.message });
                }
            }, (err: any) => {
                console.error('Error taking conversation', err);
                self.ld.showLoading(false, { message: this._translationService.translate('UnknownError') });
            });
        });
    }

    dismiss(object: any = null) {
        this.modalCtrl.dismiss({ 'dismissed': true, 'object': object });
        // Check if saveOrderIsLoading to avoid calling reorderTemplates() when the saveOrder() is running
        if (this.orderChanged && !this.saveOrderIsLoading) {
            // Reorder templates in DB if the order has changed
            const reorderResult = this.reorderTemplates();
            if (reorderResult) {
                this.orderChanged = false;
                this.saveOrderButtonLabel = 'No changes to save';
            }
        }
    }

    async saveOrder() {
        this.saveOrderButtonLabel = 'Saving...';
        this.saveOrderIsLoading = true;
        const reorderResult = await this.reorderTemplates();
        if (reorderResult) { 
            this.orderChanged = false;
            this.saveOrderButtonLabel = 'No changes to save';
        }
        this.saveOrderIsLoading = false;
    }

    loadUserTemplates() {
        let self = this;

        self.ws.invokeURL('user_templates', {}).subscribe((result: any) => {
            if (result.error === 0) {
                let myTemplates = [];
                let adminTemplates = [];

                //Divide the temples in 2 categories
                result.templates.forEach((template) => {
                    if (template.uploaded_by !== 'A') {
                        myTemplates.push(template);
                    } else {
                        adminTemplates.push(template);
                    }
                });

                //Save the total length of templates to hide the "Load more Templates"
                this.totalMyTemplates = myTemplates.length;
                this.totalAdminTemplates = adminTemplates.length;

                //Load user templates in local storage when user logs in
                this.allMyTemplates = myTemplates.sort((a, b) => a.template_order - b.template_order);
                this.allAdminTemplates = adminTemplates.sort((a, b) => a.template_order - b.template_order);
                localStorage.setItem('myTemplatesInstorage', JSON.stringify(this.allMyTemplates));
                localStorage.setItem('adminTemplatesInstorage', JSON.stringify(this.allAdminTemplates));
                // this.loadMoreTemplates();
            }
        });
    }

    loadMoreData(event) {
        // Only run this function once at a time if the user is scrolling and this somehow gets called multiple times
        if (this.isLoadMoreRunning) {
            return;
        }
        this.isLoadMoreRunning = true;

        if (this.searchtemplate.length > 0) {
            this.loadMoreSearchedTemplates();
            // Complete the event after data has loaded
            event.target.complete();
        } else {
            this.loadMoreTemplates();
            // Complete the event after data has loaded
            event.target.complete();
        }
        this.isLoadMoreRunning = false;
    }

    disableLoadMore() {
        if (this.searchtemplate.length > 0) {
            // TODO: Convert to a simple return instead of if-false-else-true
            if (this.myTemplates.length < this.myTemplatesSearched.length || this.adminTemplates.length < this.adminTemplatesSearched.length) {
                return false;
            }
            return true;
        } else {
            // TODO: Convert to a simple return instead of if-false-else-true
            if (this.myTemplates.length < this.totalMyTemplates || this.adminTemplates.length < this.totalAdminTemplates) {
                return false;
            }
            return true
        }
    }
}
